export default "__VITE_ASSET__dxSZLBWV__"